<script setup lang="ts">
    import { Minus } from 'lucide-vue-next';
    import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
    import { Voucher } from '@/types';
    import { computed } from 'vue';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useVoucherStore } from '@/stores/voucher';

    const { t } = useI18n();

    const voucherStore = useVoucherStore();

    const props = defineProps<{
        selectedVouchers: Voucher[];
    }>();

    const invalidVouchers = computed(() =>
        props.selectedVouchers.filter((voucher) => !voucher.valid_for_removal),
    );

    const validVouchers = computed(() =>
        props.selectedVouchers.filter((voucher) => voucher.valid_for_removal),
    );

    const remove = () => {
        if (invalidVouchers.value.length) {
            toast.error(t('vouchers.select.remove_confirm.invalid_header'), {
                description: t('vouchers.select.remove_confirm.invalid_description', {
                    body: invalidVouchers.value
                        .map((voucher) => `#${voucher.VoucherNumber}`)
                        .join(', '),
                }),
            });
            return;
        }

        voucherStore.setValidVouchers(validVouchers.value);
        voucherStore.toggleOpen('remove', true);
    };
</script>

<template>
    <DropdownMenuItem @click="remove">
        {{ t('vouchers.select.remove') }}
        <Minus class="text-destructive" />
    </DropdownMenuItem>
</template>
